import { useTranslation } from 'react-i18next'

import { Avatar, AVATAR_HEIGHT_24 } from '../../Avatar'
import { TableCellBase, TableCellText } from '../../Table'

import {
  getRentalPortalApplicantPortalAvatarProps,
  getRentalPortalApplicantPortalLabel,
} from './RentalPortalApplicantPortalCell.utils'

import * as styles from './RentalPortalApplicantPortalCell.module.css'

function RentalPortalApplicantPortalCell({ applicant, ...cellProps }) {
  const { t } = useTranslation()

  return (
    <TableCellBase {...cellProps}>
      <Avatar
        {...getRentalPortalApplicantPortalAvatarProps({ applicant, t })}
        className={styles.logo}
        size={AVATAR_HEIGHT_24}
      />
      <TableCellText
        value={getRentalPortalApplicantPortalLabel({ applicant, t })}
      />
    </TableCellBase>
  )
}

export default RentalPortalApplicantPortalCell
